<template>
  <label class="ms-radio">
    <input
      type="radio"
      :checked="isChecked"
      :value="value"
      :disabled="disabled"
      @change="$emit('change', $event.target.value)"
    />
    <span class="checkmark"></span>
    {{ label }}
  </label>
</template>

<script>
export default {
  name: "JpRadio",
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    label: { type: String, default: "", required: true },
    modelValue: { default: null },
    value: { default: null },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    isChecked() {
      return this.modelValue == this.value;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/components/msRadio.scss";
</style>
